import React from "react";
import {
    Snackbar,
    SnackbarContent,
    TableCell,
    Typography
} from "@material-ui/core";

export const RemoveUserSnackbar = ({
    removeSuccess,
    removeFail,
    setModalState
}) => {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
            }}
            autoHideDuration={6000}
            open={removeSuccess || removeFail}
            onClose={() => {
                setModalState();
            }}
        >
            <SnackbarContent
                style={{
                    backgroundColor: removeSuccess
                        ? "green"
                        : removeFail
                        ? "red"
                        : "white",
                    color: "white"
                }}
                message={
                    removeSuccess
                        ? "User has been successfully removed!"
                        : removeFail
                        ? "Unable To Delete User, Please Contact An Admin!"
                        : ""
                }
            />
        </Snackbar>
    );
};

export const TableHeadCell = props => {
    return (
        <TableCell>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
export const TableBodyCell = props => {
    return (
        <TableCell>
            <Typography variant="body2">{props.text}</Typography>
        </TableCell>
    );
};
